import React from 'react';
export function CtaSection() {
  return <section className="w-full bg-brand-navy py-12 md:py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-68" data-mp="3swxmnd9ty5at">
      <div className="max-w-4xl mx-auto" data-id="element-69" data-mp="c3u80z4yfw4y">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-70" data-mp="h2ose5iklsr6">
          Your competitors aren't waiting. Your team shouldn't either.
        </h2>
        <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-71" data-mp="lz5hp31iad5u">
          Book a 30-minute call. We'll look at where your team stands and figure
          out the fastest path to getting them working together on AI.
        </p>
        <div className="flex flex-col items-center space-y-6" data-id="element-72" data-mp="zu7wygs8tevb">
          <a href="#/contact/book" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm w-full sm:w-auto" data-id="element-73" data-mp="14sj42jr5lb9u">
            Book a Call
          </a>
          <p className="text-white text-base" data-id="element-74" data-mp="3nat2jgvw0zls">
            Or email me directly:{' '}
            <a href="mailto:michael@breakapencil.com" className="text-white border-b-2 border-brand-orange hover:text-brand-orange transition-colors pb-0.5" data-id="element-75" data-mp="3iaf5suzqlc32">
              michael@breakapencil.com
            </a>
          </p>
        </div>
      </div>
    </section>;
}